import { colorHex } from '@/utils/colors'
import { getDataLayerCategory } from '@/utils/layers/dataLayers'
import {
  IBaseEffect,
  IDataLayer,
  IEffect,
  IEffectCategory,
  IEffectRemedy,
  IPillLinkItem,
  IPointRankingItem,
  IRemedy,
  IRemedyCategory,
  IRemedyEffect
} from '@lifk/types'

// Typeguards for mapping function below
const isEffectCategory = (
  category: IRemedyCategory | IEffectCategory
): category is IEffectCategory => {
  return (category as IEffectCategory).categoryTextColor !== undefined
}

const isPartialRemedy = (
  item: IRemedy | IBaseEffect | IEffectRemedy | IRemedyEffect
): item is IRemedy | IEffectRemedy => {
  return (item as IRemedy | IEffectRemedy).stickerImg !== undefined
}

export const mapRemedyEffectToPillLinkItem = (
  item: IRemedy | IBaseEffect | IEffectRemedy | IRemedyEffect
): IPillLinkItem => {
  const defaultColor = colorHex('charcoal')
  const defaultTextColor = colorHex('white')
  return {
    linkType: isPartialRemedy(item) ? 'remedy' : 'effect',
    key: item.key,
    name: item.nameI18n,
    description: isPartialRemedy(item)
      ? item.descriptionI18n
      : (item as IEffect).definitionI18n,
    categoryName: item.category.name,
    budgets: isPartialRemedy(item) ? item.budgets : undefined,
    footprint: isPartialRemedy(item) ? item.footprint : undefined,
    footprintPlacement: isPartialRemedy(item)
      ? item.footprintPlacement
      : undefined,
    underlineColor: item.category.categoryColor ?? defaultColor,
    pillColor: item.category.categoryColor ?? defaultColor,
    textColor: isEffectCategory(item.category)
      ? (item.category.categoryTextColor ?? defaultTextColor)
      : defaultTextColor
  }
}

export const mapDataLayerToPillLinkItem = (
  dataLayer: IDataLayer
): IPillLinkItem => {
  const category = getDataLayerCategory(dataLayer)
  return {
    linkType: 'dataLayer',
    key: dataLayer.key,
    name: dataLayer.name,
    description: dataLayer.shortDescription,
    categoryName: category.name,
    underlineColor: category.color,
    pillColor: category.color,
    textColor: colorHex('charcoal'),
    dataLayer
  }
}

export const mapRemedyEffectToRankingItem = (
  item: IEffectRemedy | IRemedyEffect
): IPointRankingItem => {
  const pillLinkItem = mapRemedyEffectToPillLinkItem(item)
  return {
    ...pillLinkItem,
    level: item.level,
    points: item.points,
    icon: isPartialRemedy(item) ? item.stickerImg : undefined
  }
}
